import React from "react";
import { Box, Typography } from "@mui/material";

const SmsSettings = () => {
    return (
        <Box sx={{ marginTop: 3, padding: 3 }}>
            <Typography variant="h6">Sms Ayarları</Typography>
            {/* Öğrenci ekleme formu buraya gelecek */}
        </Box>
    );
};

export default SmsSettings;
